<div class="circle" matTooltip="{{ getHintLabel() }}">
                <mat-icon class="centered" [ngStyle]="getIconStyle()">{{ getIcon() }}</mat-icon>
              </div>